import { AnimatePresence, motion } from "framer-motion";

export default function PhoneConsentSlide({ open, children }) {
  return (
    <AnimatePresence initial={false}>
      {open ? (
        <motion.div
          key="sms-consent"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.28, ease: [0.4, 0, 0.2, 1] }}
          className="overflow-hidden"
        >
          {children}
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
